import { List, Show, Details, PropertyGroups, PropertyItems } from "../Components/index.js";

export default [
    {
        path: "/report/item",
        component: List,
        name: "report.property.item",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/property-group",
        component: PropertyGroups,
        name: "report.property.group",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/property-items",
        component: PropertyItems,
        name: "report.property.items",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/item/:id/details",
        component: Details,
        name: "report.property.item.details",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/report/store/:id/product-details', component: Edit, name: 'property.store.edit'},
];
